import angular from 'angular';
import uiRouter from 'angular-ui-router';
import campaignComponent from './campaign.component';
import campaignListComponent from './campaign-list.component';
import campaignDetailComponent from './campaign-detail.component';
import campaignService from './campaign.service';

let campaignModule = angular.module('campaign', [
  uiRouter
])

.service('Campaign', campaignService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/campaign');

  $stateProvider
    .state('campaign', {
      component: 'campaign'
    })
    .state('campaign.list', {
      url: '/campaign',
      component: 'campaignList'
    })
    .state('campaign.create', {
      url: '/campaign/new',
      component: 'campaignDetail',
      params: {
      	id: ""
      }
    })
    .state('campaign.edit', {
      url: '/campaign/:id/edit',
      component: 'campaignDetail',
      params: {
        id: ""
      }
    });
})

.component('campaign', campaignComponent)
.component('campaignList', campaignListComponent)
.component('campaignDetail', campaignDetailComponent)

.name;

export default campaignModule;



// WEBPACK FOOTER //
// ./client/app/components/campaign/campaign.js